export const NAMESPACE = {
  FORUM: "forum",
  AUTH: "auth",
};
export const GROUP_TYPE = {
  STUDENTGROUP: "STUDENT_GROUP",
};

export const FORUM_TOPIC_VIEW_MODE = {
  MAIN: "MAIN",
  LIST: "LIST",
};

export const FORUM_TOPIC_RESOURCE_TYPE = {
  STUDENT_GROUP: "STUDENT_GROUP",
  LESSON_ACTIVITY_COMPONENT: "LESSON_ACTIVITY_COMPONENT",
  LESSON_TEACHER_REVIEW: "LESSON_TEACHER_REVIEW",
  LESSON_ADMIN_REVIEW: "LESSON_ADMIN_REVIEW",
};

export const RESOURCE_TYPE = {
  POST: "POST",
  POLL: "POLL",
};

export const FORUM_NOTIFICATION_ACTION_TYPE = {
  POST: "POST",
  POLL: "POLL",
  TOPIC: "TOPIC",
};

export const OPTION_DISPLAY_MODE = {
  MCQ: { value: "MCQ", label: "poll_type_mcq_label" },
  SLIDER: { value: "SLIDER", label: "poll_type_slider_label" },
};

export const POLL_ANSWER_TYPE = {
  MCQ_SINGLE: "MCQ_SINGLE",
  MCQ_MULTIPLE: "MCQ_MULTIPLE",
  SLIDER: "SLIDER",
};

export const CONTEXT_TYPE = {
  FORUM_TOPIC: "FORUM_TOPIC",
};

export const POLLING_INTERVAL = 45000;

export const CHARACTER_LIMIT = {
  TITLE: 250,
  KEYWORD_TAGS: 250,
};

export const FORUM_MODE = {
  MAIN: "MAIN",
  POLL_LIST: "POLL_LIST",
  TOPIC_LIST: "TOPIC_LIST",
  SINGLE: "SINGLE",
};

export const DEFAULT_FORUM_PAGE_SIZE = {
  FORUM_TOPIC_LIST: 20,
  MAIN: 3,
  FORUM_POLL_LIST: 12,
};
